import { stripHtml } from "src/modules/shared/utils/utils";
import {SanteFamilleCodeEnum} from "src/modules/tarificateur/model/sante-famille-code.enum";
import {extractColumnTable} from "src/modules/shared/data-transformer/utils";

/**
 * Convertit une réponse du webservice de tableau de garantie en donnée tableau
 * @param {*} data la réponse du ws de tarification Santé
 * @param {*} format le callback de formatage
 * @param {*} numberOfLevel le nombre de niveau max
 * @returns une liste de données formaté pour l'affichage sous forme de tableau
 */
 const convertWarrantyTableResponseIntoTables = (data, format, numberOfLevel) => {
  console.debug('[WarrantyTableDataTransformer]', 'convertWarrantyTableResponseIntoTables', 'numberOfLevel', numberOfLevel)

  const examplesTables = []
  const warrantyTables = []

  // pour chaque type de tableaux
  Object.keys(data).forEach(key => {
    const mainNode = data[key]
    const label = mainNode.libelle

    let currentNumberOfLevel = numberOfLevel
    if (label === SanteFamilleCodeEnum.PREVENTION) {
      currentNumberOfLevel = 4
    }

    const uniqueSubKey = Object.keys(mainNode.sousFamilles)[0]
    const warrantyTableNode = mainNode.sousFamilles[uniqueSubKey].garanties
    const { lines: warrantyTableLines } = convertWarrantyTableResponseNodeIntoLines(warrantyTableNode)
    extractColumnTable(warrantyTables, warrantyTableLines, label, format, currentNumberOfLevel, 'Niveau')

    const examplesTableNode = mainNode.exemples
    const { lines: exampleTableLines } = convertWarrantyTableResponseNodeIntoLines(examplesTableNode)
    extractColumnTable(examplesTables, exampleTableLines, label, format, currentNumberOfLevel, 'Niveau')
  });

  return {
    examplesTables,
    warrantyTables
  }
}

/**
 * Converti une liste de donnée en ligne d'1 tableau
 * @param {*} node le noeud JSON à convertir
 * @returns un tableau de lines de tableau
 */
const convertWarrantyTableResponseNodeIntoLines = (node) => {
  console.debug('[WarrantyTableDataTransformer]', 'convertWarrantyTableResponseNodeIntoLines', node)

  // on détermine le nombre de level max pour recréer les headers
  let maxLevel = 0
  const lines = []

  Object.keys(node).forEach(key => {
    const mainNode = node[key]
    const cells = []

    // l'entête est extraite
    const cell = {
      label: mainNode.libelle,
      value: { moreInfo:stripHtml(mainNode.info) }, // Le HTML ne peut pas être interprété par le ToolTip
      always_visible : node[key].always_visible // La première cellule porte l'information si la ligne est toujours visible
    }
    cells.push(cell)

    // on transforme les niveaux en data
    const levelsNode = mainNode.niveaux
    let lastlevelKey = undefined
    Object.keys(levelsNode).forEach(key2 => {
      const line = {
        label: levelsNode[key2],
        value: { level: key2 },
      }
      cells.push(line)
      lastlevelKey = key
    })
    lines.push(cells)

    if (maxLevel < parseInt(lastlevelKey)) {
      maxLevel = parseInt(lastlevelKey)
    }
  })

  return {
    maxLevel,
    lines
  }
}

export { convertWarrantyTableResponseIntoTables }
